export var NAME = 'digitalEdit';
export var DIGITAL_EDITS_UPDATED = "".concat(NAME, "/DIGITAL_EDITS_UPDATED");
export var DIGITAL_EDIT_ARCHIVED = "".concat(NAME, "/DIGITAL_EDIT_ARCHIVED");
export var DIGITAL_EDIT_DISPLAY_UPDATED = "".concat(NAME, "/DIGITAL_EDIT_DISPLAY_UPDATED");
export var DIGITAL_EDIT_SEARCH_COMPLETED = "".concat(NAME, "/DIGITAL_EDIT_SEARCH_COMPLETED");
export var DIGITAL_EDIT_SEARCH_REQUESTED = "".concat(NAME, "/DIGITAL_EDIT_SEARCH_REQUESTED");
export var DOWNLOAD_URL_REQUESTED = "".concat(NAME, "/DOWNLOAD_URL_REQUESTED");
export var DOWNLOAD_URL_REQUEST_COMPLETE = "".concat(NAME, "/DOWNLOAD_URL_REQUEST_COMPLETE");
export var DOWNLOAD_URL_REQUEST_PROGRESS = "".concat(NAME, "/DOWNLOAD_URL_REQUEST_PROGRESS");
export var ACCESS_TYPE = {
  DIGITAL_PURCHASE: 'subscription-type',
  PREFERRED_GROUP: 'preferred-group-type',
  NONE: 'none'
};
export var NUMBER_OF_SECONDS_BETWEEN_UPDATES = 30;
export var STATUS_PROCESSING = 'processing';
export var STATUS_COMPLETED = 'completed';
export var STATUS_FAILED = 'failed';
export var STATUSES = {
  STATUS_PROCESSING: STATUS_PROCESSING,
  STATUS_COMPLETED: STATUS_COMPLETED,
  STATUS_FAILED: STATUS_FAILED
};